import React, { useState } from 'react';
import { sort } from 'utils/sort';
import Criterion from './Criterion';

const GradingCriteria = ({
  criteriaRatings,
  ratingOptions,
  preview,
  answerId,
  onChange,
  showComments,
}) => {
  const [hoverCount, setHoverCount] = useState(0);
  const sortedCriteria = sort(criteriaRatings, 'name');

  const adjustHoverCount = newHoverCount => {
    setHoverCount(newHoverCount);
  };

  return (
    <div className="CriteriaList">
      {sortedCriteria.map(criterion => (
        <Criterion
          criterion={criterion}
          ratingOptions={ratingOptions}
          preview={preview}
          key={answerId + criterion.id}
          answerId={answerId}
          onChange={onChange}
          showComments={showComments}
          setHoverCount={adjustHoverCount}
          hoverCount={hoverCount}
        />
      ))}
    </div>
  );
};

export default GradingCriteria;
